module.exports = __webpack_public_path__ + "media/images/page/lp-sample_large4-41e098d9401f51010ef84c5f0bb05338.jpg";